import List from "@/components/list";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  // async function restore(params) {
  //   const text = "确定恢复共享该视频吗?";
  //   await Confirm(text);
  //   recoveryVideo({ uuids: params }).then(res => {
  //     if (!res || res.code != 0) return;
  //     Message({
  //       message: "恢复成功",
  //       type: "success"
  //     });
  //     Bus.$emit("reloadShare");
  //   });
  // }

  // const Deal = ({ props: { vo } }) => {
  //   let dep = vo.row;
  //   const dealConf = [
  //     ["icon-restore", "恢复共享", () => restore([dep.sharedToVideoId])]
  //   ];
  //   return (
  //     <div class="deal-group">
  //       {dealConf.map(item =>
  //         dep.isDelete === "1" ? (
  //           <el-tooltip content={item[1]} placement="top">
  //             <i class={item[0]} onClick={item[2]}></i>
  //           </el-tooltip>
  //         ) : (
  //           <span>-</span>
  //         )
  //       )}
  //     </div>
  //   );
  // };
  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "学院名称",
      prop: "deptName"
    },
    {
      label: "共享状态",
      prop: "sharedStatusName"
    },
    {
      label: "是否删除",
      prop: "isDeleteName"
    }
    // {
    //   label: "操作",
    //   minWidth: "100",
    //   fixed: "right",
    //   align: "center",
    //   render: vo => <Deal vo={vo} />
    // }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
